"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StatefulTextarea;

var React = _interopRequireWildcard(require("react"));

var _statefulContainer = _interopRequireDefault(require("./stateful-container.js"));

var _textarea = _interopRequireDefault(require("./textarea.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


function StatefulTextarea(props) {
  return React.createElement(_statefulContainer.default, props, function (childrenProps) {
    return React.createElement(_textarea.default, childrenProps);
  });
}